export default {
  login: 'session - log in',
  delete: 'clickedButton_deleteUser',
  edit: 'clickedButton_editUser',
  register: 'clickedButton_addUser',
  create: 'clickedButton_createdUser',
  status: 'clickedToggle_statusUser',
  update: 'clickedButton_updateUser',
}
